<template>
    <div v-if="isLoggedIn && isPayItForward" class="container page">
        <div>
            <sitecode-image src="topShoutOut.jpg" class="img-fluid w-100" />
        </div>

        <section v-if="displayPart==0" class="card card-default">
            <div class="card-header">
                <h5>Pay It Forward Recognition</h5>
                <i>
                    Pay It Forward is an act of “Ubuntu”/Generosity/Kindness from one to another.
                    This functionality allows you, the sender to share earned points as a gesture of goodwill to others.
                    This can be for congratulating, well wishes or a simple act of generosity.
                </i>
            </div>
            <div class="card-body">
                <div class="mb-3 alert alert-warning">
                    <b>Note:</b><br />
                    Points from Pay It Forward will be deducted from your <b>Personal Profile</b> and cannot be reversed once issued.
                </div>

                <div class="row">
                    <div class="col-sm-6"><strong>Recipients:</strong></div>
                    <div class="col-sm-6 text-right"></div>
                </div>
                <div v-for="r in selectedMems" :key="r._rowNum" class="row">
                    <template v-if="r.isEntireDivision">
                        <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                        <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                    </template>
                    <template v-else>
                        <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                        <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                        <div class="col">{{ r.division }}</div>
                    </template>
                </div>
                <div v-if="selectedMems.length===0" class="text-danger">Please select a recipient.</div>
                <div class="mt-1">
                    <b-button type="button" pill @click="$bvModal.show('modalChooseNominees')" variant="primary" size="sm" class="mt-2">{{selectedMems.length===0 ? 'Select' : 'Change'}}  Recipient</b-button>
                    <!--<a href="#" @click.prevent="$bvModal.show('modalChooseNominees')">Select Nominees</a>-->
                </div>

                <hr />
                <b-form @submit.prevent="onSubmitReward" novalidate>
                    <b-form-group id="groupReason" label-for="selectreason" label="Value:" :invalid-feedback="fReward.errors.reason" description="">
                        <b-form-select id="selectreason" v-model="fReward.form.reason" :state="fReward.state.reason">
                            <b-form-select-option :value="null">-- Select a Value --</b-form-select-option>
                            <b-form-select-option value="Thank You!">Thank You!</b-form-select-option>
                            <b-form-select-option value="You made a difference!">You made a difference!</b-form-select-option>
                            <b-form-select-option value="You're the best!">You're the best!</b-form-select-option>
                            <b-form-select-option value="Thumbs up to you!">Thumbs up to you!</b-form-select-option>
                            <b-form-select-option value="You rock, Well done!">You rock, Well done!</b-form-select-option>
                            <b-form-select-option value="Congratulations!">Congratulations!</b-form-select-option>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group id="groupPoints" label-for="selectPoints" label="Points Amount:" :invalid-feedback="fReward.errors.points" description="" :state="fReward.state.points">
                        <b-form-select id="selectPoints" v-model="fReward.form.points" :state="fReward.state.points" :options="pointsOptions"></b-form-select>
                    </b-form-group>

                    <b-form-group id="groupSendBy" label-for="sendBy" description="" :invalid-feedback="fReward.errors.sendBy" :state="fReward.state.sendBy" class="mt-4">
                        <b-form-radio-group id="radiogroupSendBy" v-model="fReward.form.sendBy" name="sendBy" :state="fReward.state.sendBy">
                            <div class="row">
                                <div class="col-sm-3 col-lg-2">
                                    <b-form-radio value="email">Email</b-form-radio>
                                </div>
                                <div class="col-sm-3 col-lg-2">
                                    <b-form-radio value="sms">SMS</b-form-radio>
                                </div>
                            </div>
                        </b-form-radio-group>
                    </b-form-group>

                    <b-form-group id="groupRewardMessage" label-for="txtRewardMessage" label="Message to Recipients" :invalid-feedback="fReward.errors.message" :description="(isSendBySMS?150:500)-fReward.form.message.length + ' characters remaining'">
                        <b-form-textarea id="txtRewardMessage" :disabled="fReward.form.sendBy===null" v-model="fReward.form.message" :state="fReward.state.message" :placeholder="isSendBySMS ? 'Short SMS message to recipients up to 150 characters' : 'Short email message to recipients up to 500 characters'" rows="3" max-rows="5" :maxlength="(isSendBySMS?150:500)" />
                    </b-form-group>

                    <hr />

                    <div class="text-right"><b-button type="submit" variant="primary">Submit</b-button></div>
                </b-form>
            </div>
        </section>

        <section v-if="displayPart==1" class="card card-default">
            <div class="card-header">
                <h5>Pay It Forward Recognition</h5>
                <i>
                    Pay It Forward is an act of “Ubuntu”/Generosity/Kindness from one to another.
                    This functionality allows you, the sender to share earned points as a gesture of goodwill to others.
                    This can be for congratulating, well wishes or a simple act of generosity.
                </i>
            </div>
            <div class="card-body">
                <div class="alert alert-warning mb-3">
                    <b>Note:</b><br />
                    Points from Pay It Forward will be deducted from your <b>Personal Profile</b> and cannot be reversed once issued.
                </div>

                <b-alert variant="success" show>
                    <h4 class="alert-heading">Pay It Forward Recognition</h4>
                    <p>
                        Successfully submitted Pay It Forward recognition.
                    </p>
                </b-alert>
            </div>
            <div class="card-footer">
                <div class="text-right"><button type="button" @click="displayPart=0" class="btn btn-primary">Send Another</button></div>
            </div>

        </section>



        <!--
        **************************************************************************************************************************************************
                                                                    M O D A L S
        **************************************************************************************************************************************************
        -->
        <!-- Modal - Nominees -->
        <b-modal id="modalChooseNominees" title="Pay It Forward Recognition" hide-footer size="xl" no-close-on-backdrop>
            <member-select title="Select recipients"
                           selectedTitle="Recipients"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedMems"
                           :isAllowWholeDivision="false"
                           :isSingle="false"
                           :showContinue="false"
                           :memberType="isSlsRetailMassDistributionSales ? 'sls-retail-mass-distribution-sales' : ''"
                           :excludeCountryCode="isSlsRetailMassDistributionSales ? '' : 'sky'"
                           excludeDivisionCode="ra_7090,ra_7091,stm_5192"

                           class="mb-3" />

            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominees')">Done</b-button></div>
        </b-modal>

    </div>

</template>

<script>
    // @ is an alias to /src
    import SitecodeImage from '@/components/SitecodeImage';
    import axios from 'axios'
    //import sjData from '@/sjUtilData'
    import MemberSelect from '@/components/MemberSelect';


    export default {
        name: 'PayItForward',
        components: {
            MemberSelect,
            'sitecode-image': SitecodeImage
        },
        data() {
            return {
                displayPart: 0,

                fReward: {
                    form: { what: 'payitforward', reason: null, points: null, message: '', sendBy: null, recipients: [] }
                },

                selectedMems: [],

                roles: { ca: false, cc: false, idea: false, inv: false },

                reportTitle: '',


            }
        },
        computed: {
			pointsOptions() {
				const pointsList = [5, 10, 20, 25, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000, 2000, 3000, 4000, 5000];
				let p = [{ text: '--- Select Amount to Award---', value: null, disabled: true }];
				pointsList.forEach(n => p.push({ text: n + '  e-points', value: n }));
				return p;
			},
            isLoggedIn() {
                return this.$store.state.isLoggedIn
            },
            isSlsRetailMassDistributionSales() {
                return (this.memberClusterCode == 'sky' && this.memberDivisionCode != 'sky_5980');
            },
            isPayItForward() {
                return (this.memberDivisionCode != 'sky_5980'
                    && this.memberDivisionCode != 'ra_7090'
                    && this.memberDivisionCode != 'ra_7091'
                    && this.memberDivisionCode !== 'stm_5192');
            },
            countryList() {
                if (this.isCountryFixed) { //only show the default cluster.
                    return this.$store.state.countryList.filter(country => country.countryCode === this.defaultCountryCode);
                } else {
                    return [{ countryCode: null, country: '-- Please select a Cluster--', disabled: true }]
                        .concat(this.$store.state.countryList);
                }
            },
            memberClusterCode() {
                return this.$store.state.memberStore.member.clusterCode
            },
            memberDivisionCode() {
                return this.$store.state.memberStore.member.divisionCode
            },
            isSendBySMS() {
                return this.fReward.form.sendBy === 'sms';
            },
			
        },
        created() {
            //formSetState must be called on creation, to ensure all fields are setup
            this.formSetState(this.fReward, true, true) //formObj, resetState, resetForm

            this.$store
                .dispatch('getDivisionList', {})
                .then(() => {
                    this.displayPart = 0;

                })
                .catch((error) => {
                    this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error)));
                });


        },
        mounted() {

        },
        methods: {

            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },

            //*** formStatusUpdate - used to display form errors.
            //Ensure this.form contains the list of fields.
            //Call  formStatusUpdate(true) to initialise/clear the form errors.
            //formObject is the object that contains the following objects:  .form, .formState, .formErrors
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },

            onSubmitReward() {
                this.formSetState(this.fReward, true);//formObj, resetState, resetForm
                this.fReward.form.recipients = this.selectedMems.map(item => item.isEntireDivision ? 'div:' + item.entireDivisionCode : item.memberId);
                if (this.selectedMems.length === 0) {
                    this.msgBox('Please select at least one recipient.', 'Recipients required');
                    return;
                }

                //this.displayPart = 1;
                if (this.displayPart == 0) {
                    return axios
                        .post(
                            '/api/reward/doreward',
                            this.fReward.form
                        )
                        .then(({ data }) => {
                            console.log(data);
                            this.displayPart = 1;
                            this.selectedMems = [];
                            this.formSetState(this.fReward, true, true);
                            this.$store.dispatch('memberStore/getMemberData');
                        })
                        .catch((error) => {
                            this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error.response.data)));
                            if (error.response.data.formErrors) {
                                this.fReward.errors = error.response.data.formErrors;
                                this.formSetState(this.fReward);
                            }
                        })
                        ;
                }
            },

        }




    }
</script>
